<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" fullscreen>
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>{{titleAction}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn @click="cancel()" dark icon>
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-xl>
            <v-layout wrap>
              <v-flex d-flex lg12 md12 sm12 xs12>
                <v-flex d-flex lg4 md4 sm12 xs12>
                  <v-switch
                    v-model="internalAds.active"
                    :disabled="!Edit"
                    :label="$t('active')"
                    color="primary"
                  ></v-switch>
                </v-flex>
                <v-flex d-flex lg4 md4 sm12 xs12>
                  <v-text-field
                    type="number"
                    name="input-1"
                    :label="$t('width')"
                    min="1"
                    max="1000"
                    step="1"
                    maxlength="4"
                    :rules="[v => rules.vacio(v, 'width'), v => rules.min1(v, 'width')]"
                    v-model="width"
                  ></v-text-field>
                </v-flex>
                <v-flex d-flex lg4 md4 sm12 xs12>
                  <v-text-field
                    :label="$t('height')"
                    :min="1"
                    :max="1000"
                    :step="1"
                    type="number"
                    :maxlength="4"
                    :rules="[v => rules.vacio(v, 'height'), v => rules.min1(v, 'height')]"
                    v-model="height"
                  ></v-text-field>
                </v-flex>
              </v-flex>
              <v-flex d-flex lg12 md12 sm12 xs12>
                <v-flex md4 sm6 xs12>
                  <v-text-field :disabled="true" prepend-icon="attach_file" v-model="titleFile">
                    <template slot="label">{{$t('adsImage')}}</template>
                  </v-text-field>
                  <upload-button
                    :fileChangedCallback="fileChanged"
                    :title="titleButton"
                    :disabled="!Edit"
                  />
                </v-flex>
                <v-flex md4 sm6 v-show="image" xs12>
                  <div>
                    <div class="resizable" id="imagecontent" :style="styleImage">
                      <resize-observer @notify="updateXY()" />
                      <figure style="width:100%; height:100%">
                        <img
                          :src="image"
                          alt="upload image"
                          style="width:100%; height:100%"
                          @load="statusImage = true"
                        />
                      </figure>
                    </div>
                  </div>
                </v-flex>
              </v-flex>
              <v-flex d-flex lg12 md12 sm12 xs12>
                <v-flex d-flex lg6 md6 sm12 xs12>
                  <v-autocomplete
                    :disabled="!Edit"
                    :items="listLocation"
                    :rules="[v => rules.vacio(v,'location')]"
                    :label="$t('select', {field :$tc('location') })"
                    persistent-hint
                    prepend-icon="mdi-city"
                    v-model="internalAds.location"
                  ></v-autocomplete>
                </v-flex>
                <v-flex d-flex lg6 md6 sm12 xs12>
                  <v-autocomplete
                    v-if="internalAds.location === 'boardTournament' || internalAds.location === 'leftRankingTournament' || internalAds.location === 'rightRankingTournament'"
                    :disabled="!Edit"
                    :items="listTournaments"
                    :rules="[v => rules.vacio(v,'tournament')]"
                    :label="$t('select', {field :$tc('tournament') })"
                    persistent-hint
                    prepend-icon="mdi-city"
                    v-model="internalAds.tournamentId"
                  ></v-autocomplete>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="reset()" color="warning" small v-if="Edit">{{$t('reset')}}</v-btn>
          <v-btn
            @click="sendCreate()"
            color="success"
            small
            :loading="loading"
            v-if="externalAction==='create'"
          >{{$t('create')}}</v-btn>
          <v-btn
            @click="sendUpdate()"
            color="secondary"
            small
            :loading="loading"
            v-if="externalAction === 'update'"
          >{{$t('update')}}</v-btn>
          <v-btn
            @click="sendDelete()"
            color="error"
            small
            :loading="loading"
            v-if="externalAction === 'delete'"
          >{{$t('delete')}}</v-btn>
          <v-btn @click="cancel()" color="primary" small>{{$t('cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import UploadButton from 'vuetify-upload-button'
import queueToast from '../../../helpers/queueToast'
import rules from '../../../helpers/rules'

export default {
  name: 'formGestion',
  mixins: [rules],
  components: {
    UploadButton
  },
  props: {
    modal: {
      type: Boolean,
      required: true
    },
    externalAction: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      image: null,
      file: '',
      titleFile: '',
      internalAds: {},
      Edit: false,
      listLocation: [
        {
          text: this.$t('chronometerSimple'),
          value: 'chronometerSimple'
        },
        {
          text: this.$t('chronometerMatch'),
          value: 'chronometerMatch'
        },
        {
          text: this.$t('boardTournament'),
          value: 'boardTournament'
        },
        {
          text: this.$t('leftRankingTournament'),
          value: 'leftRankingTournament'
        },
        {
          text: this.$t('rightRankingTournament'),
          value: 'rightRankingTournament'
        }
      ],
      height: NaN,
      width: NaN,
      statusImage: true,
      loading: false
    }
  },
  watch: {
    image: function() {
      if (!this.statusImage) {
        this.updateXY()
      }
    },
    selectAds: function(val) {
      this.updateAction(this.externalAction)
    },
    externalAction: function(val) {
      this.updateAction(val)
    }
  },
  mounted() {
    let me = this
    this.updateAction(me.externalAction)
  },
  computed: {
    ...mapState({
      selectAds: state => state.advertising.Selected,
      listTournaments: state => state.tournaments.listSelect
    }),

    titleAction() {
      switch (this.externalAction) {
        case 'create':
          return this.$t('newModel', { field: this.$tc('advertising') })
        case 'delete':
          return this.$t('deleteModel', { field: this.$tc('advertising') })
        case 'update':
          return this.$t('updateModel', { field: this.$tc('advertising') })
      }
    },
    dialog: {
      get() {
        return this.modal
      },
      set(val) {
        if (!val) {
          this.$emit('close')
        }
      }
    },
    titleButton() {
      return this.image
        ? this.$t('change', { field: this.$t('image') })
        : this.$t('upload', { field: this.$t('image') })
    },
    styleImage() {
      if (!this.statusImage) {
        if (
          this.externalAction === 'delete' ||
          this.externalAction === 'update'
        ) {
          return `height: ${this.selectAds.height}px; width: ${this.selectAds.width}px`
        }
        return 'height:auto; width: auto;'
      }
      const height = parseInt(this.height) > 0 ? this.height + 'px' : 'auto'
      const width = parseInt(this.width) > 0 ? this.width + 'px' : 'auto'
      return `height: ${height}; width: ${width}`
    }
  },
  methods: {
    ...mapActions({
      createNew: 'advertising/setNew',
      updateAds: 'advertising/setUpdate',
      deleteAds: 'advertising/setEliminate'
    }),
    updateXY() {
      const element = document.getElementById('imagecontent')
      this.height = element.clientHeight
      this.width = element.clientWidth
    },
    validateBeforeSend() {
      this.internalAds.height = this.height
      this.internalAds.width = this.width
      let result = true
      let message = []
      if (this.image === '') {
        result = false
        message.push(this.$t('error.required', { field: this.$t('image') }))
      }
      if (!this.internalAds.width || parseInt(this.internalAds.width) < 1) {
        result = false
        message.push(this.$t('error.required', { field: this.$tc('width') }))
      }
      if (!this.internalAds.height || parseInt(this.internalAds.height) < 1) {
        result = false
        message.push(this.$t('error.required', { field: this.$tc('height') }))
      }
      if (
        this.internalAds.location === 'boardTournament' ||
        this.internalAds.location === 'leftRankingTournament' ||
        this.internalAds.location === 'rightRankingTournament'
      ) {
        if (!this.internalAds.tournamentId) {
          result = false
          message.push(
            this.$t('error.required', { field: this.$tc('adsLocation') })
          )
        }
      }
      return {
        result,
        message
      }
    },
    createAds() {
      return {
        active: this.internalAds.active,
        img: 'no imagen',
        file: this.file,
        width: this.width,
        height: this.height,
        location: this.internalAds.location,
        tournamentId: this.internalAds.tournamentId
      }
    },
    resolveLocal() {
      if (this.internalAds.img) {
        this.image = process.env.VUE_APP_IMAGE_URL + this.internalAds.img
      }
    },
    reset() {
      this.internalAds = {}
      this.image = ''
      this.file = null
    },
    cancel() {
      this.reset()
      this.dialog = false
    },
    sendCreate() {
      const error = this.validateBeforeSend()
      if (!error.result) {
        queueToast(error.message)
        return
      }
      this.loading = true
      this.createNew(this.createAds())
        .then(_ => {
          this.dialog = false
          this.reset()
        })
        .finally(_ => (this.loading = false))
    },
    sendUpdate() {
      const response = this.validateBeforeSend()
      if (!response.result) {
        queueToast(response.message)
        return
      }
      let sendData = this.createAds()
      sendData._id = this.selectAds._id

      if (!sendData.file) {
        delete sendData.img
      }

      this.loading = true
      this.updateAds(sendData)
        .then(_ => {
          this.dialog = false
          this.reset()
        })
        .finally(_ => (this.loading = false))
    },
    sendDelete() {
      this.loading = true
      this.deleteAds(this.selectAds._id)
        .then(_ => {
          this.dialog = false
          this.reset()
        })
        .finally(_ => (this.loading = false))
    },
    fileChanged(file) {
      if (file.size < 1) return
      this.createImage(file)
    },
    createImage(file) {
      this.file = file
      this.titleFile = file.name
      const image = new Image()
      const reader = new FileReader()
      const vm = this

      reader.onload = e => {
        vm.image = e.target.result
      }
      reader.onloadend = () => {
        vm.height = 0
        vm.width = 0
      }
      reader.readAsDataURL(file)
    },
    updateAction(val) {
      this.file = null
      this.statusImage = false
      switch (val) {
        case 'create':
          this.internalAds = {}
          this.Edit = true
          break
        case 'update':
          this.height = parseInt(this.selectAds.height)
          this.width = parseInt(this.selectAds.width)
          this.internalAds = Object.assign({}, this.selectAds)
          this.titleFile = this.selectAds.img
          this.Edit = true
          break
        default:
          this.height = parseInt(this.selectAds.height)
          this.width = parseInt(this.selectAds.width)
          this.internalAds = Object.assign({}, this.selectAds)
          this.titleFile = this.selectAds.img
          this.Edit = false
      }
      let me = this
      if (!this.statusImage) {
        me.statusImage = true
      }
      setTimeout(function() {
        me.resolveLocal()
      }, 1000)
    }
  }
}
</script>
<style scoped lang="scss">
.resizable {
  resize: both;
  overflow: hidden;
  padding: 10px;

  &:hover {
    border: 1px dotted #000000;
    box-shadow: 2px 2px 20px;
  }
}
</style>
